import * as yup from "yup";

export const validationSchema = yup.object().shape({
  expiry_date: yup.string().required("Expiry date is required"),

  couponType: yup
    .string()
    .oneOf(["REFERRAL", "GIVEAWAY"], "Invalid coupon type")
    .required("Coupon type is required"),

  couponValueType: yup
    .string()
    .oneOf(["AMOUNT", "PERCENTAGE"], "Invalid value type")
    .required("Value type is required"),

  couponAmount: yup
    .number()
    .transform((value, originalValue) =>
      originalValue.trim() === "" ? undefined : value
    )
    .when("couponValueType", {
      is: "AMOUNT",
      then: (schema) =>
        schema
          .typeError("Coupon amount must be a number")
          .required("Coupon amount is required")
          .positive("Amount must be greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),

  couponDiscount: yup
    .number()
    .transform((value, originalValue) =>
      originalValue.trim() === "" ? undefined : value
    )
    .when("couponValueType", {
      is: "PERCENTAGE",
      then: (schema) =>
        schema
          .typeError("Discount must be a number")
          .required("Coupon discount is required")
          .min(1, "Discount must be at least 1%")
          .max(100, "Discount cannot exceed 100%"),
      otherwise: (schema) => schema.notRequired(),
    }),
});
